
import { Table, TableBody, TableFooter, TableRow, TableCell } from '@/components/ui/table';
import { Card } from '@/components/ui/card';
import { TeacherReportTableHeader } from './salary/TeacherReportTableHeader';
import { TeacherReportTableRow } from './salary/TeacherReportTableRow';
import { ReportDetail } from '@/types/salary';
import { AlertTriangle } from 'lucide-react';

interface TeacherReportDetailsProps {
  reportDetails: ReportDetail[];
  totalSalaryFromReport?: number;
}

export function TeacherReportDetails({ reportDetails, totalSalaryFromReport }: TeacherReportDetailsProps) {
  const calculatedTotal = reportDetails.reduce((sum, r) => sum + (r.salary || 0), 0);
  const hasMismatch = totalSalaryFromReport !== undefined && Math.abs(calculatedTotal - totalSalaryFromReport) > 0.01;

  return (
    <Card>
      <div className="p-6">
        <h3 className="text-lg font-semibold mb-4">รายละเอียดรายงาน</h3>
        <div className="overflow-x-auto">
          <Table>
            <TeacherReportTableHeader />
            <TableBody>
              {reportDetails.map((report, index) => (
                <TeacherReportTableRow key={index} report={report} />
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TableCell colSpan={7} className="text-right font-semibold">
                  รวมรายได้จากการสอน
                </TableCell>
                <TableCell className="font-semibold">
                  {calculatedTotal.toLocaleString()} บาท
                </TableCell>
                <TableCell colSpan={3} />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
        {hasMismatch && (
          <div className="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded-lg flex items-center gap-2 text-yellow-700">
            <AlertTriangle className="w-4 h-4 shrink-0" />
            <span className="text-sm">
              ยอดรวมจากรายละเอียด ({calculatedTotal.toLocaleString()} บาท) ไม่ตรงกับยอดรายได้จากการสอน ({totalSalaryFromReport?.toLocaleString()} บาท)
            </span>
          </div>
        )}
      </div>
    </Card>
  );
}
